import { useEffect, useState } from "react";
import { Card, Tag, Progress } from "antd";
import StarIcon from "@mui/icons-material/Star";
import AssessmentIcon from "@mui/icons-material/Assignment";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import axios from "axios";
import { BaseUrl , AssesmentUrl} from "../Constants/Constants";
import "./StatusCard.css";

export const CareerProgressCard = () => {
  const profile = JSON.parse(localStorage.getItem("Profile"));
  const userId = profile?.user_id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;

    axios
      .post(
        `${BaseUrl}career-course-parts/career-program-status`,
        { user_id: userId },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data?.data) setData(res.data.data);
      })
      .catch((err) => {
        console.error("Career progress API error:", err);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  const progress = data
    ? Math.floor((data.totalModulesCompleted / data.totalModules) * 100)
    : 0;

  return (
    <Card className="gradebookCard">
      <div className="gradebookCardHeader">
        <div className="gradebookCardIconWrapper">
          <StarIcon className="gradebookCardIcon" />
        </div>
        <h3 className="gradebookCardTitle">Career Program Status</h3>
      </div>

      <div className="gradebookCardContent">
        {loading ? (
          <p style={{ textAlign: "center", color: "#888" }}>Loading data...</p>
        ) : (
          <>
            <div className="statusRow">
              <span className="statusLabel">Modules Completed</span>
              <span className="statusValue">
                {data.totalCoursesCompleted} / {data.totalCoursesAssigned}
              </span>
            </div>

            <div className="statusRow">
              <span className="statusLabel">Parts Completed</span>
              <span className="statusValue">
                {data.totalModulesCompleted} / {data.totalModules}
              </span>
            </div>

            <div className="progressWrapper">
              <Progress percent={progress} strokeWidth={12} />
            </div>

            {data.nextModule && (
              <div className="nextStep nextStepRow">
                <TrendingUpIcon className="nextStepIcon" />
                <div className="nextTitle">Continue: {"  "}</div>
                <div className="nextStepText">
                  <span>
                    <b className="gradientText">Module:</b>{" "}
                    {data.nextModule.course_name}
                  </span>
                  <span> | </span>
                  <span>
                    <b className="gradientText">Part:</b>{" "}
                    {data.nextModule.module_name}
                  </span>
                  <span>
                    <b className="gradientText">{"->"}</b>{" "}
                    {data.nextModule.part_name}
                  </span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Card>
  );
};


//Assesment Card
export const AssessmentStatusCard = () => {
  const profile = JSON.parse(localStorage.getItem("Profile"));
  const userId = profile?.user_id;

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userId) return;

    axios
      .post(
        `${AssesmentUrl}career_dev_assessment_status`,
        { user_id: userId },
        { withCredentials: true }
      )
      .then((res) => {
        if (res.data) {
          setData(res.data);
        }
      })
      .catch((err) => {
        console.error("Assessment status API error:", err);
      })
      .finally(() => setLoading(false));
  }, [userId]);

  const progress = data ? Math.floor(data.completion_percentage) : 0;
  const completed = data?.completed_assessment;
  const total = data?.total_assessment;
  const passed = data?.pass_count;
  const failed = data?.fail_count;
  const nextAssessment = data?.next_assessment;

  return (
    <Card className="gradebookCard">
      <div className="gradebookCardHeader">
        <div className="gradebookCardIconWrapper">
          <AssessmentIcon className="gradebookCardIcon" />
        </div>
        <h3 className="gradebookCardTitle">Assessment Status</h3>
      </div>

      <div className="gradebookCardContent">
        {loading ? (
          <p style={{ textAlign: "center", color: "#888" }}>Loading data...</p>
        ) : (
          <>
            <div className="statusRow">
              <span className="statusLabel">Assessments Completed</span>
              <span className="statusValue">
                {completed||0} / {total||0}
              </span>
            </div>

            <div className="tagRow">
              <Tag color="green" className="statusTag">
                Passed: {passed}
              </Tag>
              <Tag color="red" className="statusTag">
                Failed: {failed}
              </Tag>
            </div>

            <div className="progressWrapper">
              <Progress percent={progress} strokeWidth={12} />
            </div>

            {nextAssessment && (
              <div className="nextStep nextStepRow">
                <TrendingUpIcon className="nextStepIcon" />
                Next: <b>{nextAssessment}</b>
              </div>
            )}
          </>
        )}
      </div>
    </Card>
  );
};
